import React from "react";
import { connect } from 'react-redux'


import { Card, Col, CardBody } from "reactstrap";
    
import { StandardList } from './StandardList';


// var setupService = require ('../api');


class CollectionCrud extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
          modalOpen: false,
        };
      }

    //   componentDidMount() {

    // }

render() {
    let actions = [ 
        // { label: "Modificar", act: this.modifyParameter, type:'success' },
        // { label: "Volver Anterior", act: this.rollback, type:'warning' } ,
        // { label: "Blanquear", act: this.clean, type:'danger' }  
    ]
    // let commits = [];
    // if (!this.state.lastCommits.error) {
    //      commits = this.state.lastCommits.map( (com) => {
    //         return (
    //             { 'message': com.commit.message,
    //             'commit_date': com.commit.committer.date  }
    //         )
    //     });
    // } else {
    //     commits = [{commit_date: new Date(), message: 'ATENCION: No pude obtener las ultimas actualizaciones'}];
    // }
    // Filtro loes merges
    // commits = commits.filter( (com) => !com.message.startsWith("Merge branch") );


    return (
        <>

        <Col > 
            <Card>
                <CardBody>

                <StandardList
                    showQty={false}
                    title={this.props.title}
                    rows={this.props.collection}
                    cols={this.props.cols}
                    actions={actions}
                    />
                </CardBody>

            </Card>
        </Col>
        </>
    )
    }
}


const mapStateToProps = state => {
    return {
        view: state.view,
        school: state.config.school,
        token: state.auth.session.jwt_token,
     }
  }

  
  const mapDispatchToProps = dispatch => {
    return { 

    //   getUserDashboard: ( token ) => {
    //     dispatch( setupActions.getUserDashboard( token )) ;
    //   }
        

 
    }
  }


  export default connect(mapStateToProps, mapDispatchToProps)(CollectionCrud);

